import { ROUTES, RoutesType } from "@/shared/config";

export const publicAllowedRoutes: RoutesType[] = [ROUTES.MAIN, ROUTES.REGISTRATION];

export const protectedChannelRoutes: RoutesType[] = Object.values(ROUTES).filter((route) => {
    return !publicAllowedRoutes.includes(route as RoutesType);
}) as RoutesType[];

export const isIncludeChannelProtectedRoutes = (pathname?: string) => {
    return protectedChannelRoutes.some((path) => pathname?.startsWith(path));
};
